/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_200Inputs */

const vi_carrier_status_200 = /** @type {(inputs: Carrier_Status_200Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lấy hàng thành công`)
};

/**

* @param {Carrier_Status_200Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_200 = /** @type {((inputs?: Carrier_Status_200Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_200Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_200(inputs)
});